import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import {
  Keys,
  PersistenceService
} from 'src/app/core/services/persistence.service';

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';
import { UserCreateRequest, UserUpdateRequest } from '../models/request/class';
import { User, UserStatus } from '../models/user';
import { UserPasswordRequest } from '../models/user-password.request';
import { UserResponse } from '../models/user.response';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrlUser = `${environment.host}ms-user/api/v1/user/`;
  private baseUrlParameter = `${environment.host}ms-parameter/api/v1/parameter/`;
  private baseUrlNotify = `${environment.host}ms-notify/api/v1/notify/`;

  private _selectedUser: User;

  constructor(
    private persistenceService: PersistenceService,
    private httpService: HttpService
  ) {}

  create(newUser: UserCreateRequest): Observable<UserResponse> {
    const api = `${this.baseUrlUser}`;
    this.httpService.uri = api;
    return this.httpService.execPostJson(newUser);
  }

  findById(id: string): Observable<User> {
    const api = `${this.baseUrlUser}${id}`;
    this.httpService.uri = api;
    return this.httpService.execGetJson().pipe(
      map(userResponse => ({ ...userResponse.data, id })),
      tap((userSelected: User) => {
        this._selectedUser = userSelected;
        this.persistenceService.addValue(
          Keys.user,
          JSON.stringify(this.selectedUser)
        );
      })
    );
  }

  update(id: string, user: UserUpdateRequest): Observable<User> {
    // TODO: Definir Interface Response
    const api = `${this.baseUrlUser}${id}`;
    this.httpService.uri = api;
    return this.httpService
      .execPutJson(user)
      .pipe(
        map((userResponse: UserResponse) => ({ ...userResponse.data, id }))
      );
  }

  /**
   * Permite completar el perfil del usuario asignando su password
   * @param id identificador del usuario
   * @param password nuevo password a asignar al usaurio cuando completa su perfil
   */
  setPassword(id: string, password: UserPasswordRequest) {
    const api = `${this.baseUrlUser}password/${id}`;
    this.httpService.uri = api;
    return this.httpService.execPutJson(password);
  }

  all(): Observable<any> {
    const api = `${this.baseUrlUser}find-all`;
    this.httpService.uri = api;
    return this.httpService.execGetJson();
  }

  updateState(id: string, nextState: any) {
    const api = `${this.baseUrlUser}state/${id}`;
    this.httpService.uri = api;
    return this.httpService.execPutJson(nextState);
  }

  sendInvitation(request: any) {
    const api = `${this.baseUrlNotify}send-user`;
    this.httpService.uri = api;
    return this.httpService.execPostJson(request);
  }

  getStateUser(): Observable<any> {
    const api = `${this.baseUrlParameter}state-user`;
    this.httpService.uri = api;
    return this.httpService.execGetJson();
  }

  get selectedUser() {
    return this._selectedUser as User;
  }
}
